import { take, put, call, fork } from 'redux-saga/effects';

import { respawn } from 'yeself-client-common/utils/SagaUtils';
import log from 'yeself-client-common/utils/LogUtils';

import {
    fetchAdminOrganizationsListSuccess,
    fetchAdminOrganizationsListError,
    fetchMemberOrganizationsListError,
    fetchMemberOrganizationsListSuccess,
} from './OrganizationsAction';

import {
    fetchAdminOrganizationsListService,
    fetchMemberOrganizationsListService,
} from './OrganizationsService';

import {
    FETCH_ADMIN_ORGANIZATIONS_LIST_REQUEST,
    FETCH_MEMBER_ORGANIZATIONS_LIST_REQUEST,
} from './types';

export function* fetchAdminOrganizationsListTask() {
    try {
        const payload = yield call(fetchAdminOrganizationsListService);

        yield put(fetchAdminOrganizationsListSuccess(payload?.body?.data));
    } catch (err) {
        log.error(err);
        yield put(fetchAdminOrganizationsListError());
    }
}

export function* fetchMemberOrganizationsListTask() {
    try {
        const payload = yield call(fetchMemberOrganizationsListService);

        yield put(fetchMemberOrganizationsListSuccess(payload?.body?.data));
    } catch (err) {
        log.error(err);
        yield put(fetchMemberOrganizationsListError());
    }
}

function* fetchAdminOrganizationsListWatcher() {
    while (true) {
        yield take(FETCH_ADMIN_ORGANIZATIONS_LIST_REQUEST);
        yield fork(fetchAdminOrganizationsListTask);
    }
}

function* fetchMemberOrganizationsListWatcher() {
    while (true) {
        yield take(FETCH_MEMBER_ORGANIZATIONS_LIST_REQUEST);
        yield fork(fetchMemberOrganizationsListTask);
    }
}

export default function* applicationsSaga() {
    yield respawn(fetchAdminOrganizationsListWatcher);
    yield respawn(fetchMemberOrganizationsListWatcher);
}
